// Analytics bridge — ported from eb-ui creator-collections-listing `src/_shared/analytics.ts`.
//
// `@eventbrite/legacy-infra.site-analytics` (GA) is a documented GA-ghost drop
// (GA → Heap → PicoX). The KEYS still flow through the app (trackEvent is called
// from every interactive surface) so we keep the same call sites + enums and
// no-op the GA dispatch (a faithful, honest degrade — matching the sibling
// fleet's analytics no-op / Heap-bridge precedent). Any future Heap/PicoX
// instrumentation hangs off `trackEvent` here.
import type { ServerData } from '@/types';

export enum AnalyticsCategory {
    EventCard = 'eventcard',
    Collections = 'creator-collections',
    Create = 'creator-collections-create',
    Listing = 'creator-collections-listing',
    RelatedEvents = 'related-events',
}

export enum AnalyticsAction {
    AutoCollectionInitiate = 'AutoCollectionInitiate',
    CollectionPromote = 'CollectionPromote',
    CollectionView = 'CollectionView',
    CopyURL = 'CopyURL',
    DevicePreview = 'DevicePreview',
    EditCollection = 'EditCollection',
    EventsShowMore = 'EventsShowMore',
    EventsTabClick = 'EventsTabClick',
    OrganizerName = 'OrganizerName',
    PreviewPage = 'PreviewPage',
}

/** GA init (site-analytics) — dropped; no-op kept so the bootstrap call site survives. */
export const initAnalytics = (_props: ServerData): void => {
    // (GA initDimensionsFromState / trackInitialPageView dropped — see module comment.)
};

export interface TrackEventPayload {
    action: AnalyticsAction;
    label: string;
    category: AnalyticsCategory;
    dimensions?: Record<string, unknown>;
}

/**
 * Dispatch an analytics event. The GA dispatch is a faithful no-op (GA ghost
 * drop); this is the single seam where Heap/PicoX instrumentation attaches.
 */
export const trackEvent = (_payload: TrackEventPayload): void => {
    // (GA trackAnalyticsEvent dropped.)
};
